import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import { ALCOHOL_AGE_VERIFIED_KEY } from '@fdc/constants/local-storage-keys.constants';
import { useGlobalLocalStorageState } from '@fdc/hooks/useGlobalLocalStorageState';

import { localStorageService } from '@contentservice/shared/services/storage/local-storage.service';

const alcoholAgeVerifiedVar = makeVar<boolean>(false);

export interface AlcoholAgeCheckDialogState {
  isOpen: boolean;
  onConfirm?: () => void;
  onConfirmNo?: () => void;
}

export const defaultAlcoholAgeCheckDialogState: AlcoholAgeCheckDialogState = {
  isOpen: false,
  onConfirm: undefined,
  onConfirmNo: undefined,
};

const alcoholAgeCheckDialogVar = makeVar<AlcoholAgeCheckDialogState>(
  defaultAlcoholAgeCheckDialogState
);

export const openAlcoholAgeCheckDialog = (
  onConfirm: () => void,
  onConfirmNo?: () => void
) => {
  alcoholAgeCheckDialogVar({
    isOpen: true,
    onConfirm,
    onConfirmNo,
  });
};

export const closeAlcoholAgeCheckDialog = () => {
  alcoholAgeCheckDialogVar(defaultAlcoholAgeCheckDialogState);
};

export const useAlcoholAgeCheckDialogState = () => {
  return useReactiveVar(alcoholAgeCheckDialogVar);
};

export const useAlcoholAgeVerified = () => {
  const [verified, setVerified, clearVerified] = useGlobalLocalStorageState(
    ALCOHOL_AGE_VERIFIED_KEY,
    alcoholAgeVerifiedVar
  );

  const setAlcoholAgeVerified = () => {
    setVerified(true);
  };

  const clearAlcoholAgeVerified = () => {
    clearVerified();
    alcoholAgeVerifiedVar(false);
  };

  return {
    verified,
    setAlcoholAgeVerified,
    clearAlcoholAgeVerified,
  };
};

export const clearAlcoholAgeVerifiedStatus = () => {
  alcoholAgeVerifiedVar(false);
  localStorageService.remove(ALCOHOL_AGE_VERIFIED_KEY);
};
